"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _icons = require("../../icons");

var _layout = require("../../layout");

var _tooltip = require("../../tooltip");

var _utils = require("../../utils");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _propTypes = require("./propTypes");

var _core = require("@emotion/core");

var _excluded = ["error", "htmlFor", "labelId", "labelText", "renderLabel", "required", "tooltipAlignment", "tooltipAltText", "tooltipText", "warning"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Tooltip = (0, _tooltip.withTooltip)({
  triggerVerticalAlign: 'middle'
})(_icons.IconInformationFill);

var InputHeaderBase = function InputHeaderBase(_ref) {
  var _ref$error = _ref.error,
      error = _ref$error === void 0 ? _constants.inputHeaderDefaultProps.error : _ref$error,
      htmlFor = _ref.htmlFor,
      labelId = _ref.labelId,
      labelText = _ref.labelText,
      _ref$renderLabel = _ref.renderLabel,
      renderLabel = _ref$renderLabel === void 0 ? _constants.inputHeaderDefaultProps.renderLabel : _ref$renderLabel,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? _constants.inputHeaderDefaultProps.required : _ref$required,
      tooltipAlignment = _ref.tooltipAlignment,
      _ref$tooltipAltText = _ref.tooltipAltText,
      tooltipAltText = _ref$tooltipAltText === void 0 ? _constants.inputHeaderDefaultProps.tooltipAltText : _ref$tooltipAltText,
      tooltipText = _ref.tooltipText,
      _ref$warning = _ref.warning,
      warning = _ref$warning === void 0 ? _constants.inputHeaderDefaultProps.warning : _ref$warning,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var hasTooltip = tooltipText !== undefined;
  var labelColor = _utils.LABEL_COLOR;
  var asteriskColor = _utils.LABEL_ASTERISK_COLOR;

  if (error) {
    labelColor = _utils.LABEL_ERROR_COLOR;
    asteriskColor = _utils.LABEL_ERROR_COLOR;
  } else if (warning) {
    labelColor = _utils.LABEL_WARNING_COLOR;
    asteriskColor = _utils.LABEL_WARNING_COLOR;
  }

  return (0, _core.jsx)(_helperComponents.InputHeaderView, (0, _extends2.default)({
    display: "inline"
  }, (0, _utils.pickDataProps)(forwardedProps)), renderLabel({
    htmlFor: htmlFor,
    labelId: labelId,
    color: labelColor,
    children: (0, _core.jsx)(_layout.View, {
      display: "inline",
      minHeight: _utils.A11Y_INLINE_MIN_SIZE,
      margin: hasTooltip ? {
        right: _utils.TOOLTIP_HORIZONTAL_SPACING
      } : undefined
    }, labelText, required && (0, _core.jsx)(_helperComponents.Asterisk, {
      color: asteriskColor
    }))
  }), hasTooltip && (0, _core.jsx)(Tooltip, {
    color: _utils.TOOLTIP_COLOR,
    isInline: false,
    size: _utils.DEFAULT_S_ICON_SIZE,
    title: tooltipAltText,
    tooltipText: tooltipText,
    tooltipAlignment: tooltipAlignment
  }));
};

var InputHeaderWithDocs = (0, _stencilReactDesc.describe)(InputHeaderBase).description('Header for form elements that displays a label.');
InputHeaderWithDocs.propTypes = _objectSpread({}, _propTypes.inputHeaderPropTypes);
var InputHeader = (0, _utils.withTestAttributes)({
  component: 'StencilReactInputHeader'
})(InputHeaderWithDocs);
InputHeader.defaultProps = _objectSpread({}, _constants.inputHeaderDefaultProps);
InputHeader.displayName = 'InputHeader';
var _default = InputHeader;
exports.default = _default;